export default __webpack_public_path__ + "static/media/banner-principal-desktop.78e8fb4c.jpg";